import React from 'react';
import { Box } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LoginModal from '../../components/LoginModal';
import NewHereModal from '../../components/NewHereModal';
import ContactUsModal from '../../components/ContactUsModal';
import PlansModal from '../../components/PlansModal';
import ForgotPasswordModal from '../../components/ForgotPasswordModal';
import { useUser } from '../../hooks/useUser';
import { useModals } from '../../hooks/useModals';
import { brandTokens } from '../theme';

const AppLayout = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useUser();
  const {
    contactOpen,
    plansOpen,
    setContactOpen,
    handleOpenLogin,
    handleOpenRegister,
    handleClosePlans,
    licensePlate,
    planType
  } = useModals();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: brandTokens.backgroundApp,
        color: 'text.primary',
      }}
    >
      <Header 
        onLoginClick={handleOpenLogin}
        onRegisterClick={handleOpenRegister}
      />
      
      <Box 
        component="main" 
        sx={{ 
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'transparent',
        }}
      >
        <Outlet />
      </Box>
      <Footer />

      <LoginModal />

      <NewHereModal />

      <ContactUsModal 
        open={contactOpen}
        onClose={() => setContactOpen(false)}
      />

      <PlansModal 
        open={plansOpen}
        onClose={handleClosePlans}
        licensePlate={licensePlate}
        planType={planType}
        isAuthenticated={isAuthenticated}
        handleOpenRegister={handleOpenRegister}
        navigate={navigate}
      />

      <ForgotPasswordModal />
    </Box>
  );
};

export default AppLayout;
